import React from 'react';
import { Modal, Button } from 'antd';
import { FormProvider } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { getShowBugReportForm } from 'store/selectors/general';
import { setShowBugReportForm } from 'store/actions/general';
import BugFeatureForm from './BugFeatureForm';
import useBugFeatureForm from './useBugFeatureForm';
import { useSubmitBugFeature } from 'mutation/admin';

export default function BugFeatureReportForm() {
  const visible = useSelector(getShowBugReportForm);
  const form = useBugFeatureForm();

  const onSubmitComplete = () => {
    form.reset();
    handleHideForm();
  };

  const { isLoading, mutate } = useSubmitBugFeature({
    onSuccess: onSubmitComplete,
  });

  const dispatch = useDispatch();

  const handleHideForm = () => dispatch(setShowBugReportForm(false));

  const onConfirmSubmit = values => {
    Modal.confirm({
      title: 'Confirmation',
      content: `Are you sure you want to continue?`,
      okText: 'Yes',
      okType: 'primary',
      onOk: () => submitValues(values),
      cancelText: 'No',
    });
  };

  const submitValues = values => {
    const { attachments, ...payload } = values;
    const formData = new FormData();
    attachments.forEach(a => formData.append('attachments', a));
    formData.append('payload', JSON.stringify(payload));
    mutate(formData);
  };

  return (
    <Modal
      footer={[
        <Button
          disabled={isLoading}
          key="submit"
          loading={isLoading}
          type="primary"
          onClick={form.handleSubmit(onConfirmSubmit)}
        >
          Submit
        </Button>,
      ]}
      title="Bug-Report / Feature-Request"
      visible={visible}
      onCancel={handleHideForm}
      onOk={form.handleSubmit(onConfirmSubmit)}
    >
      <FormProvider {...form}>
        <BugFeatureForm disabled={isLoading} />
      </FormProvider>
    </Modal>
  );
}
